.content {
  height: 100%;
  max-height: calc(100% - 4rem);
}
